import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Button } from '@/common/ui/button'
import useMutationDeleteDepositPromotion from '@/modules/promotion/api/hooks/useMutateDeleteDepositPromotion'
import { DepositPromotionQueryKeys } from '@/modules/promotion/keys'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'

interface DeleteAlertProps {
	id: string
}

export const DeleteAlert = ({ id }: DeleteAlertProps) => {
	const queryClient = useQueryClient()
	const { mutate: deleteDepositPromotion } = useMutationDeleteDepositPromotion({
		onSuccess: () => {
			toast.success('ลบโปรโมชั่นสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [DepositPromotionQueryKeys.GetDepositPromotionList],
			})
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteDepositPromotion({ id })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบโปรโมชั่น</AlertDialogTitle>
					<AlertDialogDescription>
						การกระทำนี้ไม่สามารถย้อนกลับได้
						โปรโมชั่นนี้จะถูกลบออกจากระบบอย่างถาวร
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction onClick={handleDelete}>ลบ</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
